<h2 mat-dialog-title>Creazione Assessment di Sostenibilità</h2>
<div mat-dialog-content class="dialog-center-cont">
  <app-cfg-questionario
    [tipoQuestionario]="'AUTOVALUTAZIONE'"
    [cfgQuestionario]="data.cfgAutovalutazione"
    (pubblicato)="pubblicato()"
  ></app-cfg-questionario>
</div>
